import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { SessionService } from '../session/session.service';

@Injectable({
  providedIn: 'root'
})
export class GetListaService {

  constructor(
    private http: HttpClient,
    private sessionService: SessionService
  ) { }

  getlista(tabela: any) {
    
    const link = `${environment.protheus}/lista?tabela=${tabela}&pj=${this.sessionService.isPJ}`;
    return this.http.get(link);
  }
}
